export type AnimationConfig = {
  [key: string]: any
}

export interface AnimationPreset {
  [state: string]: AnimationConfig | string | null
}

export const ANIMATION_DEFAULT: AnimationPreset = {
  WARN: null,
  CRITICAL: null,
  default: null
}
